export const statisticsOptions = new Map();

statisticsOptions.set('position', 'Posicionamiento')
statisticsOptions.set('peoplehasknowledge', 'Personas con conocimiento')
statisticsOptions.set('collaborationwillingness', 'Predisposición a colaborar')